"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createToggleBlock = exports.toggleBlock = exports.insertBlock = exports.createBlock = exports.createIsActive = exports.hasBlock = void 0;

var slate_1 = require("slate");

var isBlockActive = function isBlockActive(editor, format) {
  var e_1, _a;

  var match = false;
  var nodes = slate_1.Editor.nodes(editor, {
    match: function match(n) {
      return n.type === format;
    }
  });

  try {
    // ToDo: find a way how to solve the linting error and keep functionality working
    // eslint-disable-next-line no-restricted-syntax
    for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
      var _b = __read(nodes_1_1.value, 1),
          node = _b[0];

      if (node.type === format) match = true;
      break;
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return !!match;
};

exports.hasBlock = function (format, editor) {
  return isBlockActive(editor, format);
};

exports.createIsActive = function (format) {
  return function (editor) {
    return isBlockActive(editor, format);
  };
};

var DEFAULT_NODE = 'paragraph';

exports.createBlock = function (blockType, data) {
  return {
    data: data,
    type: blockType
  };
};

exports.insertBlock = function (_a) {
  var editor = _a.editor,
      blockType = _a.blockType;
  var blockNode = {
    data: {},
    type: blockType,
    children: []
  };
  slate_1.Transforms.insertNodes(editor, blockNode);
};

exports.toggleBlock = function (_a) {
  var editor = _a.editor,
      blockType = _a.blockType;
  var isActive = isBlockActive(editor, blockType);
  slate_1.Transforms.setNodes(editor, {
    type: isActive ? DEFAULT_NODE : blockType
  });
};

exports.createToggleBlock = function (blockType) {
  return function (_a) {
    var editor = _a.editor;
    return exports.toggleBlock({
      editor: editor,
      blockType: blockType
    });
  };
};